export const EMAIL_JS_USER_ID = `user_FwrG1TrIJzU8YsaUeVnUa`;
export const EMAIL_JS_SERVICE_ID = `default_service`;
export const EMAIL_JS_TEMPLATE_ID = `xstate_evac_feedback`;
